/* modeled after https://stackoverflow.com/questions/61871010/how-to-create-double-range-slider-using-native-html-input-range-and-vue-js */

Vue.component('range', {
    props: {   
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 1000
        },
        selectedRangeStart: {
            type: Number
        },
        selectedRangeEnd: {
            type: Number
        },
        selected: {
            type: Boolean,
            default: false
        },
        field: {},
    },
    data () {
        return {
            isMounted: false,
            activeRangeStart: this.selectedRangeStart,
            activeRangeEnd: this.selectedRangeEnd
        }
    },
    computed: {
        chosenMin : {
            get: function() {
                var val = this.activeRangeStart;
                return val * 1
            },
            set: function(val) {
                
                if (val * 1 > this.activeRangeEnd) {
                    this.activeRangeEnd = val * 1;
                    this.$emit("updaterange", this.activeRangeStart, this.activeRangeEnd)
                    return
                }
                this.activeRangeStart = val * 1;
                this.$emit("updaterange", this.activeRangeStart, this.activeRangeEnd)
            }
        
        },
        chosenMax : {
            get: function() {
                var val = this.activeRangeEnd * 1;
                return val * 1;
            },
            set: function(val) {
                
                if (val < this.activeRangeStart * 1) {
                    this.activeRangeStart = val * 1;
                    this.$emit("updaterange", this.activeRangeStart, this.activeRangeEnd)
                    return
                }
                this.activeRangeEnd = val * 1;
                this.$emit("updaterange", this.activeRangeStart, this.activeRangeEnd)
            }
            
        },
        step () {
            switch(this.field.data_format) {
                case 'Percent2':
                case 'Number2':
                    return '.01';
                    break;
                default:
                    return '1';
                    break;
                    
            }
        },
        minDisplay () {
            return formatSlideData(this.chosenMin, this.field.data_format);
        },
        maxDisplay () {
            return formatSlideData(this.chosenMax, this.field.data_format);
        },
        fullRange () {
            return this.max - this.min;
        },
        rangeWidth () {       
            if (!this.isMounted) {return 0;} 
            return (this.rangeWidthInclusive - this.rangeMarginLeftPX - this.rangeMarginRightPX) + "px";
        },
        rangeMarginLeftPX () {
            return (((this.chosenMin - this.min) / this.fullRange) * this.rangeWidthInclusive) + 9;
            return "5%";
        },
        rangeMarginLeft () {
            return this.rangeMarginLeftPX + "px";
        },
        rangeMarginRightPX () {
            //return (((this.max - this.chosenMax) / this.fullRange) * this.rangeWidthInclusive) + 9;            
            return (((this.max - this.chosenMax) / this.fullRange) * this.rangeWidthInclusive) - 9 + 9;            
            return 115;
        },
        rangeMarginRight () {
            return this.rangeMarginRightPX + "px";
        },
        rangeWidthInclusive () {            
            if (!this.isMounted) {return 0;}
            return this.$refs.sliderange.clientWidth;
        }
    },
    mounted () {
        this.isMounted = true;
        if (this.selected) {
            this.$emit("updaterange", this.activeRangeStart, this.activeRangeEnd)
        }
    }    
});
